import log from './log';

const darkStyles = {
		chart: {
			backgroundColor: '#0e1011',
			fontColor: '#a1a1a1',
			rsiLabelsFontColor: '#666565',
			markerBorderColor: '#000'
		},
		toggle: {
			checked: '#000',
			unchecked: '#000',
			toggleBackgroundColor: '#000',
			toggleCheckedBackgroundColor: '#2b2f3a',
			toggleColor: '#505050',
			toggleCheckedColor: '#d6d8df'
		},
		tabs: {
			textColor: '#7E7F7F',
			activeTextColor: '#fff',
			activeTabColor: '#161d2a14',
			tabIndicatorColor: '#7E7F7F'
		},
		backgroundColor: '#0e1011',
		textColor: '#fff',
		fontColor: '#fff',
		marketStatColor: '#161d2a',
		tabsColor: '#fff',
		textMuted: '#a1988a',
		linkColor: '#D8DEE8',
		linkHoverColor: '#FFFFFF',
		hintUnderlineColor: 'rgba(138, 148, 166, 0.46)',
		hintUnderlineHoverColor: 'rgba(248, 250, 252, 0.72)',
		mdcButtonTextColor: '#fff',
		mdcOutlinedButtonBackgroundColor: '#1f2430',
		mdcOutlinedButtonBorderColor: '#34384D',
		marketPortfolioActiveBackgroundColor: '#34384D',
		marketPortfolioActiveTextColor: '#fff',
		viewFilterActiveBackgroundColor: '#3F4652',
		viewFilterActiveTextColor: '#F8FAFC',
		coinNameColor: '#b0b0b0',
		coinPriceColor: '#b0b0b0',
		coinHoveredColor: '#1f222e',
		listStripeBackgroundColor: 'rgba(63, 70, 82, 0.28)',
		inputPlaceholderColor: '#989898',
		inputLineColor: 'rgba(255, 255, 255, 0.19)',
		searchInputBackgroundColor: '#1A1F2A',
		searchInputFocusBackgroundColor: '#202636',
		searchInputBorderColor: '#3F4652',
		searchInputFocusBorderColor: '#8A94A6',
		bottomViewFiltersColor: '#1d2238',
		alertOversoldColor: '#88ff71',
		alertOverboughtColor: '#ff2f23',
		waitColor: 'rgba(71, 71, 71, 0.45)',
		surface: '#0e1011',
		settingsDialogSurface: '#171B24',
		settingsTabActiveBackgroundColor: '#3F4652',
		settingsTabActiveTextColor: '#F8FAFC',
		rankColor: '#1e1e1e',
		shareButtonsColor: '#1d2238'
	};

const lightStyles = {
		chart:{
			backgroundColor: '#fff',
			fontColor: '#616161',
			rsiLabelsFontColor: 'rgba(0, 0, 0, 0.34)',
			markerBorderColor: '#6c757d'
		},
		toggle: {
			checked: '#000',
			unchecked: '#000',
			toggleBackgroundColor: 'rgb(241, 241, 241)',
			toggleCheckedBackgroundColor: '#eaeefe',
			toggleColor: '#6e6e6e',
			toggleCheckedColor: '#323232'
		},
		tabs: {
			textColor: '#6c757d',
			activeTextColor: '#1d2238',
			activeTabColor: '#f4f4f4',
			tabIndicatorColor: '#1d2238'
		},
		backgroundColor: '#fff',
		textColor: 'rgba(0, 0, 0, 0.87)',
		fontColor: '#000',
		marketStatColor: '#EAEEFF',
		tabsColor: '#fff',
		textMuted: '#6c757d',
		linkColor: '#34384D',
		linkHoverColor: '#1d2238',
		hintUnderlineColor: 'rgba(74, 78, 103, 0.28)',
		hintUnderlineHoverColor: 'rgba(74, 78, 103, 0.62)',
		mdcButtonTextColor: '#1d2238',
		mdcOutlinedButtonBackgroundColor: '#f4f4f4',
		mdcOutlinedButtonBorderColor: 'rgba(0, 0, 0, 0.12)',
		marketPortfolioActiveBackgroundColor: '#34384D',
		marketPortfolioActiveTextColor: '#fff',
		viewFilterActiveBackgroundColor: '#D8DEE8',
		viewFilterActiveTextColor: '#1F2937',
		coinNameColor: '#4f4f4f',
		coinPriceColor: '#4f4f4f',
		coinHoveredColor: '#f2f4fc',
		listStripeBackgroundColor: 'rgba(241, 243, 246, 0.95)',
		inputPlaceholderColor: 'rgba(0, 0, 0, 0.54)',
		inputLineColor: 'rgba(0, 0, 0, 0.28)',
		searchInputBackgroundColor: '#F1F3F6',
		searchInputFocusBackgroundColor: '#F7F8FA',
		searchInputBorderColor: 'rgba(0, 0, 0, 0.12)',
		searchInputFocusBorderColor: '#34384D',
		bottomViewFiltersColor: '#EAEEFF',
		alertOversoldColor: '#138000',
		alertOverboughtColor: '#ce0b01',
		waitColor: 'rgba(211, 211, 211, 0.45)',
		surface: '#fff',
		settingsDialogSurface: '#fff',
		settingsTabActiveBackgroundColor: '#1d2238',
		settingsTabActiveTextColor: '#fff',
		rankColor: '#e9e9e9',
		shareButtonsColor: '#aeaeae'
	};

const Darkmode = {
	get: (darkmode) => { return darkmode ? darkStyles : lightStyles; }
}

export default Darkmode;
